/**
 * We often need to transform a list to a value key mapping. This hook does this based on a key in the data
 * @param data
 * @param key
 * @returns
 */
const mapValueKey = <T>(data: T[], key = 'guid'): Record<string, T> => {
  const result: Record<string, T> = {}
  for (const item of data) {
    // @ts-ignore
    const lookupKey = item[key]
    if (typeof lookupKey === 'string') {
      result[lookupKey] = item
    } else {
      throw new Error(`Key ${String(key)} is not a string.`)
    }
  }
  return result
}

export default mapValueKey
